var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"itemlist"},_vm._l((_vm.filterData()),function(item){return _c('item',{key:item.id,staticClass:"listitem list-complete-item",attrs:{"item":item}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }